<template>
  <div>
    <img 
      :src="url" 
      :style="{ width: '100%' }" 
      alt="图片" 
      referrerpolicy="no-referrer"
    />
  </div>
</template>

<script>
export default {
  name: 'officialAccountImg',
  mounted() {
    // 设置 document 的 title
    document.title = this.$route.query.title;
  },
  computed: {
    // 修改计算属性，对 url 进行解码
    url() {
      const encodedUrl = this.$route.query.url;
      return encodedUrl ? decodeURIComponent(encodedUrl) : '';
    }
  }
};
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>